
export default {
  
    methods: {
        success(message){
            this.notifyVue('success', '<strong>SUCESSO: </strong>'+'<strong>'+message+'</strong>', 'done')        
        },

        danger(message){
            this.notifyVue('danger', '<strong>ERRO: </strong>'+'<strong>'+message+'</strong>', 'clear')        
        },

        info(message){
            this.notifyVue('info', '<strong>INFORMAÇÃO: </strong>'+'<strong>'+message+'</strong>', 'volume_mute')        
        },

        warning(message){
            this.notifyVue('warning', '<strong>ATENÇÃO: </strong>'+'<strong>'+message+'</strong>', 'priority_high')        
        },

        notifyVue(type, message, icon) {
            this.$notify({
                timeout: 10000,
                message: message,
                icon: icon,
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: type
            });
        },

        msgErrors(e){
            if (e == 'Error: Network Error') {
                this.danger('Servidor fora do ar, tente mais tarde.')
                return 'Servidor fora do ar, tente mais tarde.'
            } else if (e.response.status === 403) {
                this.$router.push({name: 'login'})
                return 'Acesso não Autorizado - Erro: 403'
            } else if (e.response.status === 401) {
                this.$router.push({name: 'login'})
                return 'Sem Autenticação - Erro: 401'
            } else {
                this.danger(e.response.data.message)
                return e.response.data.message
            }
        }

    }
}
